const servicePages = {
    aiDx: {
        slug: "ai-dx",
        canonical: "https://www.napire.co.jp/ai-dx.html",
        pageTitle: {
            ja: "\u6CD5\u4EBA\u5411\u3051AI\u30FBDX\u5C0E\u5165\u652F\u63F4 | \u682A\u5F0F\u4F1A\u793ENAPIRE",
            en: "Enterprise AI & DX Implementation | NAPIRE Inc."
        },
        metaDescription: {
            ja: "NAPIRE\u306E\u6CD5\u4EBA\u5411\u3051AI\u30FBDX\u5C0E\u5165\u652F\u63F4\u3002\u751F\u6210AI\u30FBRAG\u3001\u753B\u50CF\u8A8D\u8B58\u3001\u9700\u8981\u4E88\u6E2C\u304B\u3089\u30C7\u30FC\u30BF\u57FA\u76E4\u30FBMLOps\u307E\u3067\u3002PoC\u3067\u7D42\u308F\u3089\u305B\u305A\u3001\u73FE\u5834\u3067\u4F7F\u308F\u308C\u308BAI\u3092\u8A2D\u8A08\u30FB\u5B9F\u88C5\u3057\u307E\u3059\u3002",
            en: "NAPIRE helps enterprises ship AI and DX\u2014from GenAI/RAG and computer vision to forecasting, data platforms, and MLOps. We build systems that survive production, not just PoC decks."
        },
        keywords: {
            ja: "AI\u5C0E\u5165\u652F\u63F4,DX,\u751F\u6210AI,RAG,LLM,\u6A5F\u68B0\u5B66\u7FD2,MLOps,\u30C7\u30FC\u30BF\u57FA\u76E4,\u6CD5\u4EBA\u5411\u3051,\u30B3\u30F3\u30B5\u30EB\u30C6\u30A3\u30F3\u30B0,NAPIRE",
            en: "AI implementation,DX,GenAI,RAG,LLM,machine learning,MLOps,data platform,enterprise,NAPIRE"
        },
        hero: {
            eyebrow: {
                ja: "Enterprise AI / DX",
                en: "Enterprise AI / DX"
            },
            title: {
                ja: "AI\u306F\u3001\u5C0E\u5165\u3057\u305F\u77AC\u9593\u304B\u3089\u59CB\u307E\u308B\u3002",
                en: "AI starts the moment you ship."
            },
            lead: {
                ja: "\u30C4\u30FC\u30EB\u3092\u5165\u308C\u305F\u3060\u3051\u3067\u306F\u3001\u73FE\u5834\u306F\u52D5\u304D\u307E\u305B\u3093\u3002NAPIRE\u306F\u8AB2\u984C\u306E\u8F2A\u90ED\u3065\u3051\u304B\u3089\u30A2\u30EB\u30B4\u30EA\u30BA\u30E0\u9078\u5B9A\u3001\u672C\u756A\u904B\u7528\u30FB\u30AC\u30D0\u30CA\u30F3\u30B9\u307E\u3067\u4E00\u6C17\u901A\u8CAB\u3067\u4F34\u8D70\u3002\u81EA\u793EAI\u30C9\u30ED\u30FC\u30F3\u3067\u57F9\u3063\u305F\u300C\u30CF\u30FC\u30C9\u3068\u30BD\u30D5\u30C8\u3092\u540C\u3058\u30C1\u30FC\u30E0\u3067\u63E1\u308B\u300D\u5B9F\u88C5\u529B\u3092\u3001\u6CD5\u4EBA\u306EDX\u306B\u3082\u6D3B\u304B\u3057\u307E\u3059\u3002",
                en: "Buying tools doesn't move the floor. NAPIRE partners from problem framing through model choice, production ops, and governance\u2014the same hardware\u2013software discipline we use on our own AI drones, applied to your DX."
            },
            cta: {
                ja: "\u7121\u6599\u76F8\u8AC7\u3092\u4E88\u7D04",
                en: "Book a free consult"
            }
        },
        questions: {
            heading: {
                ja: "\u3053\u3093\u306A\u9055\u548C\u611F\u3001\u3042\u308A\u307E\u305B\u3093\u304B\uFF1F",
                en: "Sound familiar?"
            },
            items: [
                {
                    q: {
                        ja: "PoC\u306F\u6210\u529F\u3057\u305F\u306E\u306B\u3001\u672C\u756A\u306B\u4E57\u3089\u306A\u3044",
                        en: "The PoC worked\u2014production never did"
                    },
                    a: {
                        ja: "\u30C7\u30FC\u30BF\u54C1\u8CEA\u30FB\u6A29\u9650\u30FB\u904B\u7528\u30D5\u30ED\u30FC\u3092\u6700\u521D\u304B\u3089\u8A2D\u8A08\u306B\u7D44\u307F\u8FBC\u307F\u3001\u30B9\u30B1\u30FC\u30EB\u524D\u63D0\u306E\u30A2\u30FC\u30AD\u30C6\u30AF\u30C1\u30E3\u3067\u5B9F\u88C5\u3057\u307E\u3059\u3002",
                        en: "We bake data quality, access, and ops into the architecture from day one\u2014so scale isn't a surprise retrofit."
                    }
                },
                {
                    q: {
                        ja: "\u751F\u6210AI\u3092\u5165\u308C\u305F\u304C\u3001\u8AB0\u3082\u4F7F\u3063\u3066\u3044\u306A\u3044",
                        en: "GenAI landed\u2014nobody uses it"
                    },
                    a: {
                        ja: "\u30E6\u30FC\u30B9\u30B1\u30FC\u30B9\u3092\u696D\u52D9\u30D5\u30ED\u30FC\u306B\u843D\u3068\u3057\u8FBC\u307F\u3001RAG\u30FB\u30D7\u30ED\u30F3\u30D7\u30C8\u30FB\u8A55\u4FA1\u6307\u6A19\u307E\u3067\u542B\u3081\u3066\u300C\u4F7F\u308F\u308C\u308B\u5F62\u300D\u306B\u4ED5\u4E0A\u3052\u307E\u3059\u3002",
                        en: "We anchor use cases in real workflows\u2014RAG, prompts, and evaluation metrics included\u2014so adoption isn't wishful thinking."
                    }
                },
                {
                    q: {
                        ja: "\u30D9\u30F3\u30C0\u30FC\u4EFB\u305B\u3067\u3001\u793E\u5185\u306B\u30CE\u30A6\u30CF\u30A6\u304C\u6B8B\u3089\u306A\u3044",
                        en: "Vendors leave\u2014no capability stays behind"
                    },
                    a: {
                        ja: "\u8A2D\u8A08\u5224\u65AD\u306E\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u5316\u3068\u30CF\u30F3\u30BA\u30AA\u30F3\u79FB\u7BA1\u3092\u6A19\u6E96\u5316\u3002\u6B21\u306E\u6539\u5584\u30B5\u30A4\u30AF\u30EB\u3092\u81EA\u8D70\u3067\u304D\u308B\u72B6\u614B\u3092\u76EE\u6307\u3057\u307E\u3059\u3002",
                        en: "We document design decisions and run hands-on handoffs so your team can own the next improvement loop."
                    }
                }
            ]
        },
        services: {
            heading: {
                ja: "\u63D0\u4F9B\u9818\u57DF",
                en: "What we deliver"
            },
            items: [
                {
                    title: {
                        ja: "\u751F\u6210AI / LLM\u30FBRAG",
                        en: "GenAI, LLMs & RAG"
                    },
                    desc: {
                        ja: "\u793E\u5185\u30CA\u30EC\u30C3\u30B8\u691C\u7D22\u3001\u696D\u52D9\u652F\u63F4\u30C1\u30E3\u30C3\u30C8\u3001\u6587\u66F8\u751F\u6210\u3002\u30CF\u30EB\u30B7\u30CD\u30FC\u30B7\u30E7\u30F3\u6291\u5236\u3068\u30B3\u30B9\u30C8\u8A2D\u8A08\u3092\u4E21\u7ACB\u3057\u305F\u30A8\u30F3\u30BF\u30FC\u30D7\u30E9\u30A4\u30BA\u5411\u3051\u5B9F\u88C5\u3002",
                        en: "Internal knowledge search, copilots, document generation\u2014enterprise builds that tame hallucination risk and inference cost."
                    }
                },
                {
                    title: {
                        ja: "Computer Vision / OCR",
                        en: "Computer vision & OCR"
                    },
                    desc: {
                        ja: "\u753B\u50CF\u691C\u77E5\u30FB\u5206\u985E\u30FB\u69CB\u9020\u5316\u3002\u73FE\u5834\u30AB\u30E1\u30E9\u3084\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u304B\u3089\u306E\u81EA\u52D5\u62BD\u51FA\u3092\u3001\u7CBE\u5EA6\u3068\u904B\u7528\u30B3\u30B9\u30C8\u306E\u30D0\u30E9\u30F3\u30B9\u3067\u8A2D\u8A08\u3002",
                        en: "Detection, classification, structuring\u2014from field cameras and documents\u2014with accuracy traded honestly against ops cost."
                    }
                },
                {
                    title: {
                        ja: "\u4E88\u6E2C\u30FB\u6700\u9069\u5316AI",
                        en: "Forecasting & optimization"
                    },
                    desc: {
                        ja: "\u9700\u8981\u4E88\u6E2C\u3001\u5728\u5EAB\u30FB\u4FA1\u683C\u6700\u9069\u5316\u3001\u7570\u5E38\u691C\u77E5\u3002\u30C9\u30EA\u30D5\u30C8\u76E3\u8996\u3068\u518D\u5B66\u7FD2\u8A2D\u8A08\u307E\u3067\u542B\u3081\u305FMLOps\u57FA\u76E4\u3092\u69CB\u7BC9\u3002",
                        en: "Demand forecasting, inventory and pricing optimization, anomaly detection\u2014with MLOps for drift monitoring and refresh."
                    }
                },
                {
                    title: {
                        ja: "\u30C7\u30FC\u30BF\u57FA\u76E4\u30FB\u5206\u6790",
                        en: "Data platforms & analytics"
                    },
                    desc: {
                        ja: "\u30ED\u30B0\u30FB\u8CA9\u58F2\u30FB\u8A2D\u5099\u30C7\u30FC\u30BF\u306E\u7D71\u5408\u3001\u7279\u5FB4\u8A2D\u8A08\u3001\u30C0\u30C3\u30B7\u30E5\u30DC\u30FC\u30C9\u3002AWS / GCP / Azure \u4E0A\u3067\u5B66\u7FD2\u30EB\u30FC\u30D7\u304C\u56DE\u308B\u5F62\u3092\u8A2D\u8A08\u3002",
                        en: "Unify logs, sales, and equipment data\u2014features and dashboards on AWS/GCP/Azure where models keep learning."
                    }
                }
            ]
        },
        process: {
            heading: {
                ja: "\u5C0E\u5165\u306E\u6D41\u308C",
                en: "How we work"
            },
            steps: [
                {
                    title: {
                        ja: "01 \u8AB2\u984C\u306E\u8F2A\u90ED\u3065\u3051",
                        en: "01 Frame the problem"
                    },
                    desc: {
                        ja: "KPI\u30FB\u5236\u7D04\u30FB\u30C7\u30FC\u30BF\u306E\u5728\u308A\u65B9\u3092\u6574\u7406\u3002ROI\u304C\u898B\u3048\u308B\u30E6\u30FC\u30B9\u30B1\u30FC\u30B9\u306B\u7D5E\u308A\u8FBC\u307F\u307E\u3059\u3002",
                        en: "Align on KPIs, constraints, and data reality\u2014narrowing to use cases with visible ROI."
                    }
                },
                {
                    title: {
                        ja: "02 \u8A2D\u8A08\u30FBPoC",
                        en: "02 Design & PoC"
                    },
                    desc: {
                        ja: "\u30A2\u30EB\u30B4\u30EA\u30BA\u30E0\u9078\u5B9A\u3068\u30A2\u30FC\u30AD\u30C6\u30AF\u30C1\u30E3\u8A2D\u8A08\u3002\u77ED\u671F\u9593\u3067\u4EEE\u8AAC\u691C\u8A3C\u3057\u3001\u672C\u756A\u524D\u63D0\u306E\u5224\u65AD\u6750\u6599\u3092\u63C3\u3048\u307E\u3059\u3002",
                        en: "Pick algorithms and architecture\u2014fast hypothesis tests that inform production decisions."
                    }
                },
                {
                    title: {
                        ja: "03 \u672C\u756A\u5B9F\u88C5",
                        en: "03 Production build"
                    },
                    desc: {
                        ja: "API\u30FBUI\u30FB\u6A29\u9650\u30FB\u76E3\u8996\u307E\u3067\u542B\u3081\u305F\u5B9F\u88C5\u3002\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u3068\u904B\u7528\u3092\u6700\u521D\u304B\u3089\u7E54\u308A\u8FBC\u307F\u307E\u3059\u3002",
                        en: "Ship APIs, UI, access, and monitoring\u2014security and ops woven in from the start."
                    }
                },
                {
                    title: {
                        ja: "04 \u904B\u7528\u30FB\u6539\u5584",
                        en: "04 Operate & improve"
                    },
                    desc: {
                        ja: "\u7CBE\u5EA6\u30E2\u30CB\u30BF\u30EA\u30F3\u30B0\u3001\u518D\u5B66\u7FD2\u3001\u30D5\u30A3\u30FC\u30C9\u30D0\u30C3\u30AF\u30EB\u30FC\u30D7\u3002\u73FE\u5834\u306E\u5909\u5316\u306B\u8FFD\u5F93\u3057\u7D9A\u3051\u308B\u4ED5\u7D44\u307F\u3092\u6B8B\u3057\u307E\u3059\u3002",
                        en: "Accuracy monitoring, retraining, feedback loops\u2014systems that evolve with the field."
                    }
                }
            ]
        },
        why: {
            heading: {
                ja: "NAPIRE\u304C\u9078\u3070\u308C\u308B\u7406\u7531",
                en: "Why NAPIRE"
            },
            items: [
                {
                    title: {
                        ja: "\u5B9F\u88C5\u307E\u3067\u63E1\u308BAI\u30C1\u30FC\u30E0",
                        en: "Builders, not slide decks"
                    },
                    body: {
                        ja: "\u7814\u7A76\u52D5\u5411\u306E\u7406\u89E3\u3068\u30D7\u30ED\u30C0\u30AF\u30B7\u30E7\u30F3\u5B9F\u88C5\u3092\u540C\u3058\u30C1\u30FC\u30E0\u304C\u62C5\u5F53\u3002\u30B3\u30F3\u30B5\u30EB\u3067\u7D42\u308F\u3089\u305A\u3001\u30B3\u30FC\u30C9\u304C\u52D5\u304F\u3068\u3053\u308D\u307E\u3067\u8CAC\u4EFB\u3092\u6301\u3061\u307E\u3059\u3002",
                        en: "One squad spans research literacy and production code\u2014we don't stop at recommendations."
                    }
                },
                {
                    title: {
                        ja: "\u81EA\u793E\u30D7\u30ED\u30C0\u30AF\u30C8\u3067\u935B\u3048\u305F\u5B9F\u88C5\u529B",
                        en: "Hardened on our own products"
                    },
                    body: {
                        ja: "\u81EA\u793EAI\u30C9\u30ED\u30FC\u30F3\u306E\u6A5F\u4F53\u8A2D\u8A08\u304B\u3089\u30A8\u30C3\u30B8\u63A8\u8AD6\u307E\u3067\u4E00\u6C17\u901A\u8CAB\u3067\u958B\u767A\u3002\u7269\u7406\u5236\u7D04\u306E\u4E2D\u3067\u52D5\u304FAI\u306E\u8A2D\u8A08\u30CE\u30A6\u30CF\u30A6\u304C\u3001\u6CD5\u4EBA\u6848\u4EF6\u306B\u3082\u6D3B\u304D\u307E\u3059\u3002",
                        en: "We ship our own AI drones end to end\u2014edge inference under physical limits informs every enterprise build."
                    }
                },
                {
                    title: {
                        ja: "\u8AAC\u660E\u53EF\u80FD\u3067\u4FDD\u5B88\u3067\u304D\u308B\u5F62",
                        en: "Explainable & maintainable"
                    },
                    body: {
                        ja: "\u30D6\u30E9\u30C3\u30AF\u30DC\u30C3\u30AF\u30B9\u306B\u983C\u3089\u305A\u3001\u610F\u601D\u6C7A\u5B9A\u8005\u3068\u73FE\u5834\u306E\u53CC\u65B9\u304C\u7406\u89E3\u3067\u304D\u308B\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3068\u8A2D\u8A08\u3092\u6B8B\u3057\u307E\u3059\u3002",
                        en: "No mystery boxes\u2014artifacts that executives and operators can both understand and extend."
                    }
                }
            ]
        },
        faq: {
            heading: {
                ja: "\u3088\u304F\u3042\u308B\u3054\u8CEA\u554F",
                en: "FAQ"
            },
            items: [
                {
                    q: {
                        ja: "\u3069\u306E\u3088\u3046\u306A\u696D\u754C\u306B\u5BFE\u5FDC\u3057\u3066\u3044\u307E\u3059\u304B\uFF1F",
                        en: "Which industries do you serve?"
                    },
                    a: {
                        ja: "\u88FD\u9020\u3001\u5C0F\u58F2\u3001\u30A8\u30CD\u30EB\u30AE\u30FC\u3001\u516C\u5171\u3001\u8FB2\u696D\u306A\u3069\u5E45\u5E83\u304F\u5BFE\u5FDC\u3002\u696D\u754C\u56FA\u6709\u306E\u30C7\u30FC\u30BF\u3068\u898F\u5236\u3092\u8E0F\u307E\u3048\u305F\u8A2D\u8A08\u3092\u884C\u3044\u307E\u3059\u3002",
                        en: "Manufacturing, retail, energy, public sector, agriculture, and more\u2014designs that respect domain data and regulation."
                    }
                },
                {
                    q: {
                        ja: "\u5C0F\u898F\u6A21\u306APoC\u304B\u3089\u59CB\u3081\u3089\u308C\u307E\u3059\u304B\uFF1F",
                        en: "Can we start with a small PoC?"
                    },
                    a: {
                        ja: "\u306F\u3044\u30024\u301C8\u9031\u9593\u7A0B\u5EA6\u306E\u30B9\u30B3\u30FC\u30D7\u3067\u4EEE\u8AAC\u691C\u8A3C\u304B\u3089\u59CB\u3081\u3001\u6210\u679C\u304C\u898B\u3048\u305F\u6BB5\u968E\u3067\u672C\u756A\u5316\u3092\u691C\u8A0E\u3059\u308B\u9032\u3081\u65B9\u304C\u53EF\u80FD\u3067\u3059\u3002",
                        en: "Yes\u20144\u20138 week scoped pilots are common; we scale to production when signals are clear."
                    }
                },
                {
                    q: {
                        ja: "\u65E2\u5B58\u306E\u30AF\u30E9\u30A6\u30C9\u74B0\u5883\u3092\u4F7F\u3048\u307E\u3059\u304B\uFF1F",
                        en: "Can you use our existing cloud?"
                    },
                    a: {
                        ja: "AWS\u3001GCP\u3001Azure \u3044\u305A\u308C\u306B\u3082\u5BFE\u5FDC\u3002\u304A\u5BA2\u69D8\u306E\u30AC\u30D0\u30CA\u30F3\u30B9\u30DD\u30EA\u30B7\u30FC\u306B\u6CBF\u3063\u305F\u69CB\u6210\u3092\u63D0\u6848\u3057\u307E\u3059\u3002",
                        en: "We work across AWS, GCP, and Azure\u2014architectures aligned with your governance policies."
                    }
                },
                {
                    q: {
                        ja: "\u793E\u5185\u306BAI\u5C02\u9580\u4EBA\u6750\u304C\u5C11\u306A\u304F\u3066\u3082\u4F9D\u983C\u3067\u304D\u307E\u3059\u304B\uFF1F",
                        en: "Can you help if we lack in-house AI talent?"
                    },
                    a: {
                        ja: "\u306F\u3044\u3002\u8A2D\u8A08\u5224\u65AD\u306E\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u5316\u3068\u30CF\u30F3\u30BA\u30AA\u30F3\u79FB\u7BA1\u3092\u6A19\u6E96\u5316\u3057\u3001\u793E\u5185\u30C1\u30FC\u30E0\u304C\u904B\u7528\u30FB\u6539\u5584\u3092\u7D99\u7D9A\u3067\u304D\u308B\u72B6\u614B\u3092\u76EE\u6307\u3057\u307E\u3059\u3002",
                        en: "Yes\u2014we document decisions and run hands-on handoffs so your team can own ongoing operations and improvements."
                    }
                },
                {
                    q: {
                        ja: "\u5B88\u79D8\u7FA9\u52D9\u30FBNDA\u306F\u3069\u306E\u3088\u3046\u306B\u6271\u3044\u307E\u3059\u304B\uFF1F",
                        en: "How do you handle confidentiality and NDAs?"
                    },
                    a: {
                        ja: "\u6A19\u6E96NDA\u306E\u7DE0\u7D50\u306B\u5BFE\u5FDC\u3057\u3066\u3044\u307E\u3059\u3002\u304A\u5BA2\u69D8\u30C7\u30FC\u30BF\u306F\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u5C02\u7528\u74B0\u5883\u3067\u6271\u3044\u3001\u8A31\u53EF\u306A\u304F\u7B2C\u4E09\u8005\u3078\u5171\u6709\u3057\u307E\u305B\u3093\u3002",
                        en: "We sign standard NDAs, use project-isolated environments, and never share customer data without approval."
                    }
                },
                {
                    q: {
                        ja: "\u958B\u767A\u671F\u9593\u306E\u76EE\u5B89\u306F\u3069\u306E\u304F\u3089\u3044\u3067\u3059\u304B\uFF1F",
                        en: "How long do projects typically take?"
                    },
                    a: {
                        ja: "PoC\u306F4\u301C8\u9031\u9593\u3001\u672C\u756A\u5B9F\u88C5\u306F3\u301C6\u30F6\u6708\u304C\u76EE\u5B89\u3067\u3059\u3002\u30B9\u30B3\u30FC\u30D7\u3068\u30C7\u30FC\u30BF\u6E96\u5099\u72B6\u6CC1\u306B\u3088\u308A\u5909\u52D5\u3057\u307E\u3059\u3002",
                        en: "PoCs run 4\u20138 weeks; production builds often 3\u20136 months\u2014depending on scope and data readiness."
                    }
                },
                {
                    q: {
                        ja: "\u30AA\u30F3\u30D7\u30EC\u30DF\u30B9\u74B0\u5883\u3067\u3082\u5BFE\u5FDC\u3067\u304D\u307E\u3059\u304B\uFF1F",
                        en: "Do you support on-premises environments?"
                    },
                    a: {
                        ja: "\u53EF\u80FD\u3067\u3059\u3002\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u8981\u4EF6\u306B\u3088\u308A\u30AF\u30E9\u30A6\u30C9\u5229\u7528\u304C\u96E3\u3057\u3044\u5834\u5408\u3082\u3001\u30AA\u30F3\u30D7\u30EC\u30FB\u9589\u57DF\u30CD\u30C3\u30C8\u30EF\u30FC\u30AF\u5411\u3051\u306E\u69CB\u6210\u3092\u63D0\u6848\u3057\u307E\u3059\u3002",
                        en: "Yes\u2014for strict security requirements we design for on-prem and closed-network deployments."
                    }
                },
                {
                    q: {
                        ja: "\u751F\u6210AI\u306E\u30CF\u30EB\u30B7\u30CD\u30FC\u30B7\u30E7\u30F3\u5BFE\u7B56\u306F\u3069\u3046\u3057\u3066\u3044\u307E\u3059\u304B\uFF1F",
                        en: "How do you mitigate GenAI hallucinations?"
                    },
                    a: {
                        ja: "RAG\u30FB\u6839\u62E0\u63D0\u793A\u30FB\u8A31\u53EF\u30EA\u30B9\u30C8\u30FB\u4EBA\u306E\u78BA\u8A8D\u30D5\u30ED\u30FC\u3092\u7D44\u307F\u5408\u308F\u305B\u3001\u7528\u9014\u306B\u5FDC\u3058\u305F\u30EA\u30B9\u30AF\u8A31\u5BB9\u5EA6\u3092\u8A2D\u8A08\u3057\u307E\u3059\u3002",
                        en: "We combine RAG, citations, allowlists, and human review\u2014tuned to each use case's risk tolerance."
                    }
                },
                {
                    q: {
                        ja: "\u8CBB\u7528\u611F\u3092\u6559\u3048\u3066\u304F\u3060\u3055\u3044\u3002",
                        en: "What does it cost?"
                    },
                    a: {
                        ja: "PoC\u306F\u6570\u767E\u4E07\u5186\u53F0\u304B\u3089\u3001\u672C\u756A\u69CB\u7BC9\u306F\u8981\u4EF6\u306B\u3088\u308A\u7570\u306A\u308A\u307E\u3059\u3002\u521D\u56DE\u76F8\u8AC7\u3067\u6982\u7B97\u30EC\u30F3\u30B8\u3092\u304A\u4F1D\u3048\u3057\u307E\u3059\u3002",
                        en: "PoCs often start in the low millions of yen (JPY); production varies\u2014we share ranges in an initial consult."
                    }
                },
                {
                    q: {
                        ja: "\u5C0E\u5165\u5F8C\u306E\u30B5\u30DD\u30FC\u30C8\u4F53\u5236\u306F\u3042\u308A\u307E\u3059\u304B\uFF1F",
                        en: "Do you offer post-launch support?"
                    },
                    a: {
                        ja: "\u904B\u7528\u76E3\u8996\u30FB\u518D\u5B66\u7FD2\u30FB\u6539\u5584\u30B5\u30A4\u30AF\u30EB\u3092\u4F34\u8D70\u3059\u308B\u4FDD\u5B88\u5951\u7D04\u306B\u5BFE\u5FDC\u3002\u30B9\u30DD\u30C3\u30C8\u652F\u63F4\u306E\u307F\u306E\u3054\u4F9D\u983C\u3082\u53EF\u80FD\u3067\u3059\u3002",
                        en: "We offer managed support for monitoring, retraining, and iteration\u2014or spot engagements as needed."
                    }
                }
            ]
        },
        cta: {
            heading: {
                ja: "\u307E\u305A\u306F\u8AB2\u984C\u306E\u8F2A\u90ED\u304B\u3089",
                en: "Start with the problem shape"
            },
            body: {
                ja: "\u8CC7\u6599\u306F\u4E0D\u8981\u3067\u3059\u3002\u30AA\u30F3\u30E9\u30A4\u30F3\u306730\u5206\u3001\u73FE\u72B6\u3068\u30B4\u30FC\u30EB\u3092\u304A\u805E\u304B\u305B\u304F\u3060\u3055\u3044\u3002",
                en: "No deck required\u2014book 30 minutes and tell us where you are and where you need to go."
            },
            button: {
                ja: "AI\u30FBDX\u5C0E\u5165\u306B\u3064\u3044\u3066\u76F8\u8AC7",
                en: "Discuss AI & DX"
            }
        }
    },
    saasCloud: {
        slug: "saas-cloud",
        canonical: "https://www.napire.co.jp/saas-cloud.html",
        pageTitle: {
            ja: "SaaS\u30FB\u30AF\u30E9\u30A6\u30C9\u5C0E\u5165\u652F\u63F4 | \u682A\u5F0F\u4F1A\u793ENAPIRE",
            en: "SaaS & Cloud Implementation | NAPIRE Inc."
        },
        metaDescription: {
            ja: "NAPIRE\u306ESaaS\u30FB\u30AF\u30E9\u30A6\u30C9\u5C0E\u5165\u652F\u63F4\u3002Microsoft 365\u30FBGoogle Workspace\u3001SaaS\u30FBAI\u30FB\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u30FB\u30AF\u30E9\u30A6\u30C9\u88FD\u54C1\u306E\u4ED5\u5165\u308C\u304B\u3089\u79FB\u884C\u30FB\u5B9A\u7740\u307E\u3067\u3002AI\u4F01\u696D\u306A\u3089\u3067\u306F\u306E\u30C7\u30FC\u30BF\u9023\u643A\u30FB\u81EA\u52D5\u5316\u8996\u70B9\u3067\u3001\u5C0E\u5165\u5F8C\u306B\u4F7F\u308F\u308C\u308B\u74B0\u5883\u3092\u69CB\u7BC9\u3057\u307E\u3059\u3002",
            en: "NAPIRE delivers SaaS and cloud\u2014from Microsoft 365 and Google Workspace to SaaS, AI, security, and cloud product procurement, migration, and adoption\u2014with an AI-native lens on integration and automation."
        },
        keywords: {
            ja: "SaaS\u5C0E\u5165,\u30AF\u30E9\u30A6\u30C9\u5C0E\u5165,Microsoft 365,Google Workspace,GWS,SaaS,AI,\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3,\u30AF\u30E9\u30A6\u30C9,\u88FD\u54C1\u4ED5\u5165\u308C,\u30E9\u30A4\u30BB\u30F3\u30B9,PC,\u6CD5\u4EBA\u5411\u3051,NAPIRE",
            en: "SaaS implementation,cloud migration,Microsoft 365,Google Workspace,GWS,AI,security,procurement,licensing,PC,NAPIRE,enterprise"
        },
        hero: {
            eyebrow: {
                ja: "SaaS / Cloud",
                en: "SaaS / Cloud"
            },
            title: {
                ja: "\u5C0E\u5165\u3057\u3066\u3001\u4F7F\u308F\u308C\u308B\u307E\u3067\u3002",
                en: "Implemented\u2014and actually used."
            },
            lead: {
                ja: "\u30E9\u30A4\u30BB\u30F3\u30B9\u3092\u5951\u7D04\u3057\u305F\u3060\u3051\u3067\u306F\u3001\u7D44\u7E54\u306F\u5909\u308F\u308A\u307E\u305B\u3093\u3002NAPIRE\u306FMicrosoft 365\u30FBGoogle Workspace\u3092\u306F\u3058\u3081\u3001SaaS\u30FBAI\u30FB\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u30FB\u30AF\u30E9\u30A6\u30C9\u88FD\u54C1\u306E\u9078\u5B9A\u30FB\u4ED5\u5165\u308C\u304B\u3089\u79FB\u884C\u3001\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u8A2D\u8A08\u3001\u7814\u4FEE\u30FB\u904B\u7528\u5B9A\u7740\u307E\u3067\u4F34\u8D70\u3002PC\u7B49\u306EIT\u6A5F\u5668\u63D0\u4F9B\u3082\u9806\u6B21\u5BFE\u5FDC\u4E88\u5B9A\u3067\u3059\u3002",
                en: "Licenses alone don't transform teams. NAPIRE partners from product selection and procurement\u2014Microsoft 365, Google Workspace, SaaS, AI, security, and cloud\u2014through migration, security design, training, and adoption. PC and hardware supply coming soon."
            },
            cta: {
                ja: "\u5C0E\u5165\u306B\u3064\u3044\u3066\u76F8\u8AC7",
                en: "Talk implementation"
            }
        },
        questions: {
            heading: {
                ja: "\u5C0E\u5165\u306E\u73FE\u5834\u3067\u3001\u3088\u304F\u805E\u304F\u58F0",
                en: "What we hear in the field"
            },
            items: [
                {
                    q: {
                        ja: "M365\u3084GWS\u3092\u5165\u308C\u305F\u304C\u3001\u73FE\u5834\u3067\u6D3B\u7528\u3067\u304D\u3066\u3044\u306A\u3044",
                        en: "M365 or GWS is live\u2014but teams aren't using it"
                    },
                    a: {
                        ja: "\u696D\u52D9\u30D5\u30ED\u30FC\u306B\u6CBF\u3063\u305F\u8A2D\u8A08\u3068\u6BB5\u968E\u7684\u306A\u5C55\u958B\u8A08\u753B\u3067\u3001\u30C4\u30FC\u30EB\u304C\u300C\u7FA9\u52D9\u300D\u3067\u306F\u306A\u304F\u300C\u5F53\u305F\u308A\u524D\u300D\u306B\u306A\u308B\u904B\u7528\u3092\u3064\u304F\u308A\u307E\u3059\u3002",
                        en: "Workflow-aligned design and phased rollouts\u2014so tools feel natural, not mandated."
                    }
                },
                {
                    q: {
                        ja: "SaaS\u30FBAI\u30FB\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u88FD\u54C1\u3092\u8907\u6570\u30D9\u30F3\u30C0\u30FC\u304B\u3089\u307E\u3068\u3081\u3066\u4ED5\u5165\u308C\u305F\u3044",
                        en: "We want one partner for SaaS, AI, and security products"
                    },
                    a: {
                        ja: "Microsoft 365\u30FBGoogle Workspace\u3001\u5404\u7A2ESaaS\u3001AI\u30FB\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u30FB\u30AF\u30E9\u30A6\u30C9\u88FD\u54C1\u306E\u9078\u5B9A\u30FB\u4ED5\u5165\u308C\u304B\u3089\u5C0E\u5165\u30FB\u5B9A\u7740\u307E\u3067\u4E00\u62EC\u3067\u652F\u63F4\u3057\u307E\u3059\u3002",
                        en: "We handle selection and procurement for M365, Google Workspace, SaaS, AI, security, and cloud\u2014through rollout and adoption."
                    }
                },
                {
                    q: {
                        ja: "\u5C0E\u5165\u5F8C\u306E\u30B5\u30DD\u30FC\u30C8\u4F53\u5236\u304C\u5F31\u304F\u3001\u793E\u5185\u306B\u77E5\u898B\u304C\u6B8B\u3089\u306A\u3044",
                        en: "Post-go-live support is thin\u2014knowledge doesn't stay"
                    },
                    a: {
                        ja: "\u7BA1\u7406\u8005\u5411\u3051\u30CF\u30F3\u30BA\u30AA\u30F3\u3068\u904B\u7528\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3092\u6A19\u6E96\u5316\u3002\u5185\u88FD\u5316\u3092\u898B\u636E\u3048\u305F\u30CA\u30EC\u30C3\u30B8\u79FB\u8EE2\u3092\u884C\u3044\u307E\u3059\u3002",
                        en: "Hands-on admin training and runbooks\u2014knowledge transfer aimed at self-sufficiency."
                    }
                }
            ]
        },
        services: {
            heading: {
                ja: "\u63D0\u4F9B\u9818\u57DF",
                en: "What we deliver"
            },
            items: [
                {
                    title: {
                        ja: "\u30D7\u30ED\u30C0\u30AF\u30C8\u4ED5\u5165\u308C\u30FB\u30E9\u30A4\u30BB\u30F3\u30B9\u63D0\u4F9B",
                        en: "Product procurement & licensing"
                    },
                    desc: {
                        ja: "Microsoft 365\u30FBGoogle Workspace\u3001\u5404\u7A2ESaaS\u3001AI\u30FB\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u30FB\u30AF\u30E9\u30A6\u30C9\u88FD\u54C1\u306E\u9078\u5B9A\u30FB\u4ED5\u5165\u308C\u3002\u5229\u7528\u90E8\u9580\u3068\u8981\u4EF6\u304B\u3089\u6700\u9069\u306A\u30D7\u30E9\u30F3\u3092\u6574\u7406\u3057\u3001\u904E\u5270\u30E9\u30A4\u30BB\u30F3\u30B9\u3092\u6291\u3048\u305F\u69CB\u6210\u3092\u63D0\u6848\u3057\u307E\u3059\u3002",
                        en: "Procurement for Microsoft 365, Google Workspace, SaaS, AI, security, and cloud products\u2014right-sized plans mapped to departments and requirements."
                    }
                },
                {
                    title: {
                        ja: "Microsoft 365 / Google Workspace",
                        en: "Microsoft 365 & Google Workspace"
                    },
                    desc: {
                        ja: "\u30C6\u30CA\u30F3\u30C8\u8A2D\u8A08\u3001\u30E9\u30A4\u30BB\u30F3\u30B9\u6700\u9069\u5316\u3001Teams\u30FBSharePoint\u30FBPower Platform / Google Workspace \u5404\u7A2E\u30B5\u30FC\u30D3\u30B9\u306E\u696D\u52D9\u9069\u7528\u3002\u30BB\u30DF\u30CA\u30FC\u30FB\u7814\u4FEE\u306B\u3088\u308B\u5B9A\u7740\u652F\u63F4\u3082\u5B9F\u65BD\u3002",
                        en: "Tenant design, license optimization, Teams/SharePoint/Power Platform and Google Workspace for real work\u2014plus training for adoption."
                    }
                },
                {
                    title: {
                        ja: "\u30AF\u30E9\u30A6\u30C9\u79FB\u884C\u30FBIaaS/PaaS",
                        en: "Cloud migration & IaaS/PaaS"
                    },
                    desc: {
                        ja: "AWS / GCP / Azure \u3078\u306E\u6BB5\u968E\u7684\u79FB\u884C\u3002\u65E2\u5B58\u30B7\u30B9\u30C6\u30E0\u3068\u306E\u5171\u5B58\u3001\u30CD\u30C3\u30C8\u30EF\u30FC\u30AF\u30FBID\u8A2D\u8A08\u3092\u542B\u3081\u305F\u30A2\u30FC\u30AD\u30C6\u30AF\u30C1\u30E3\u7B56\u5B9A\u3002",
                        en: "Phased moves to AWS/GCP/Azure\u2014coexistence with legacy, network and identity architecture included."
                    }
                },
                {
                    title: {
                        ja: "\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u88FD\u54C1\u30FB\u30AC\u30D0\u30CA\u30F3\u30B9",
                        en: "Security products & governance"
                    },
                    desc: {
                        ja: "EDR\u30FBSASE\u30FBIAM\u7B49\u306E\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u88FD\u54C1\u306E\u9078\u5B9A\u30FB\u4ED5\u5165\u308C\u304B\u3089\u3001\u30A2\u30AF\u30BB\u30B9\u5236\u5FA1\u3001\u30ED\u30B0\u76E3\u8996\u3001\u30B3\u30F3\u30D7\u30E9\u30A4\u30A2\u30F3\u30B9\u5BFE\u5FDC\u307E\u3067\u3002AI\u5229\u7528\u3092\u898B\u636E\u3048\u305F\u30C7\u30FC\u30BF\u5206\u985E\u30FB\u6A29\u9650\u8A2D\u8A08\u3082\u542B\u3081\u307E\u3059\u3002",
                        en: "Security product selection and procurement\u2014EDR, SASE, IAM\u2014plus access control, logging, compliance, and data classification for AI use."
                    }
                },
                {
                    title: {
                        ja: "SaaS\u30FBAI \u30C4\u30FC\u30EB\u9023\u643A\u30FB\u81EA\u52D5\u5316",
                        en: "SaaS & AI integration"
                    },
                    desc: {
                        ja: "Copilot\u30FBGemini\u7B49\u306EAI\u88FD\u54C1\u5C0E\u5165\u3001API\u9023\u643A\u3001\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u81EA\u52D5\u5316\u3001\u30C7\u30FC\u30BF\u30D1\u30A4\u30D7\u30E9\u30A4\u30F3\u69CB\u7BC9\u3002\u5C0E\u5165\u3057\u305F\u30C4\u30FC\u30EB\u7FA4\u3092\u4E00\u3064\u306E\u696D\u52D9\u57FA\u76E4\u3068\u3057\u3066\u7D71\u5408\u3057\u307E\u3059\u3002",
                        en: "AI product rollout\u2014Copilot, Gemini, and more\u2014plus API wiring, workflow automation, and data pipelines into one operational fabric."
                    }
                },
                {
                    title: {
                        ja: "PC\u30FBIT\u6A5F\u5668\u306E\u63D0\u4F9B",
                        en: "PC & hardware supply (coming soon)"
                    },
                    desc: {
                        ja: "\u6CD5\u4EBA\u5411\u3051PC\u30FB\u5468\u8FBA\u6A5F\u5668\u306E\u4ED5\u5165\u308C\u30FB\u8CA9\u58F2\u3092\u9806\u6B21\u958B\u59CB\u4E88\u5B9A\u3002\u30AF\u30E9\u30A6\u30C9\u30FBSaaS\u74B0\u5883\u3068\u5408\u308F\u305B\u305F\u7AEF\u672B\u69CB\u6210\u306E\u63D0\u6848\u3082\u884C\u3044\u307E\u3059\u3002",
                        en: "Corporate PC and peripheral procurement and sales launching soon\u2014device configurations aligned with your cloud and SaaS stack."
                    }
                }
            ]
        },
        process: {
            heading: {
                ja: "\u5C0E\u5165\u306E\u6D41\u308C",
                en: "How we work"
            },
            steps: [
                {
                    title: {
                        ja: "01 \u73FE\u72B6\u628A\u63E1",
                        en: "01 Assess"
                    },
                    desc: {
                        ja: "\u65E2\u5B58\u30B7\u30B9\u30C6\u30E0\u30FB\u696D\u52D9\u30D5\u30ED\u30FC\u30FB\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u8981\u4EF6\u3092\u68DA\u5378\u3057\u3002\u30B4\u30FC\u30EB\u3068\u5236\u7D04\u3092\u660E\u78BA\u306B\u3057\u307E\u3059\u3002",
                        en: "Inventory systems, workflows, and security\u2014clarify goals and constraints."
                    }
                },
                {
                    title: {
                        ja: "02 \u9078\u5B9A\u30FB\u4ED5\u5165\u308C",
                        en: "02 Select & procure"
                    },
                    desc: {
                        ja: "M365\u30FBGWS\u3001SaaS\u30FBAI\u30FB\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u30FB\u30AF\u30E9\u30A6\u30C9\u88FD\u54C1\u306E\u9078\u5B9A\u30FB\u4ED5\u5165\u308C\u3002\u5229\u7528\u90E8\u9580\u3068\u8981\u4EF6\u304B\u3089\u6700\u9069\u306A\u69CB\u6210\u3068\u79FB\u884C\u9806\u5E8F\u3092\u7B56\u5B9A\u3057\u307E\u3059\u3002",
                        en: "Product selection and procurement\u2014M365, GWS, SaaS, AI, security, cloud\u2014mapped to departments, requirements, and migration order."
                    }
                },
                {
                    title: {
                        ja: "03 \u69CB\u7BC9\u30FB\u79FB\u884C",
                        en: "03 Build & migrate"
                    },
                    desc: {
                        ja: "\u30C6\u30CA\u30F3\u30C8\u69CB\u7BC9\u3001\u30C7\u30FC\u30BF\u79FB\u884C\u3001\u9023\u643A\u8A2D\u5B9A\u3092\u5B9F\u65BD\u3002\u30C0\u30A6\u30F3\u30BF\u30A4\u30E0\u3092\u6700\u5C0F\u5316\u3059\u308B\u6BB5\u968E\u7684\u306A\u5207\u308A\u66FF\u3048\u3092\u884C\u3044\u307E\u3059\u3002",
                        en: "Tenant setup, data moves, integrations\u2014phased cutovers that minimize downtime."
                    }
                },
                {
                    title: {
                        ja: "04 \u5B9A\u7740\u30FB\u904B\u7528",
                        en: "04 Adopt & operate"
                    },
                    desc: {
                        ja: "\u7814\u4FEE\u3001\u904B\u7528\u30DE\u30CB\u30E5\u30A2\u30EB\u3001\u30D8\u30EB\u30D7\u30C7\u30B9\u30AF\u4F53\u5236\u306E\u6574\u5099\u3002\u4F7F\u308F\u308C\u7D9A\u3051\u308B\u74B0\u5883\u3092\u793E\u5185\u306B\u6839\u4ED8\u304B\u305B\u307E\u3059\u3002",
                        en: "Training, runbooks, helpdesk patterns\u2014adoption that sticks inside your org."
                    }
                }
            ]
        },
        why: {
            heading: {
                ja: "AI\u4F01\u696D\u3060\u304B\u3089\u3067\u304D\u308B\u5C0E\u5165\u652F\u63F4",
                en: "Cloud with an AI-native lens"
            },
            items: [
                {
                    title: {
                        ja: "AI\u9023\u643A\u3092\u898B\u636E\u3048\u305F\u8A2D\u8A08",
                        en: "Built for what comes next"
                    },
                    body: {
                        ja: "\u5358\u306A\u308B\u30C4\u30FC\u30EB\u5C0E\u5165\u3067\u306F\u306A\u304F\u3001\u5C06\u6765\u306EAI\u30FB\u30C7\u30FC\u30BF\u6D3B\u7528\u3092\u898B\u636E\u3048\u305F\u30C7\u30FC\u30BF\u914D\u7F6E\u3068\u6A29\u9650\u8A2D\u8A08\u3092\u6700\u521D\u304B\u3089\u884C\u3044\u307E\u3059\u3002",
                        en: "We place data and permissions for tomorrow's AI\u2014not just today's licenses."
                    }
                },
                {
                    title: {
                        ja: "\u5B9F\u88C5\u3068\u904B\u7528\u307E\u3067\u4E00\u6C17\u901A\u8CAB",
                        en: "End-to-end delivery"
                    },
                    body: {
                        ja: "\u4ED5\u5165\u308C\u30FB\u30E9\u30A4\u30BB\u30F3\u30B9\u63D0\u4F9B\u304B\u3089\u69CB\u7BC9\u30FB\u79FB\u884C\u30FB\u7814\u4FEE\u307E\u3067\u540C\u3058\u30C1\u30FC\u30E0\u304C\u62C5\u5F53\u3002\u30D9\u30F3\u30C0\u30FC\u9593\u306E\u8ABF\u6574\u30B3\u30B9\u30C8\u3092\u6291\u3048\u307E\u3059\u3002",
                        en: "One squad from procurement and licensing through build, migration, and training\u2014less vendor coordination tax."
                    }
                },
                {
                    title: {
                        ja: "\u591A\u69D8\u306A\u88FD\u54C1\u3078\u306E\u5B9A\u7740\u652F\u63F4",
                        en: "Adoption across your stack"
                    },
                    body: {
                        ja: "M365\u30FBGWS\u30FBSaaS\u30FBAI\u88FD\u54C1\u306A\u3069\u3001\u975E\u30A8\u30F3\u30B8\u30CB\u30A2\u5411\u3051\u306E\u308F\u304B\u308A\u3084\u3059\u3044\u7814\u4FEE\u8A2D\u8A08\u3002\u73FE\u5834\u306E\u300C\u4F7F\u3048\u308B\u300D\u30EC\u30D9\u30EB\u307E\u3067\u843D\u3068\u3057\u8FBC\u307F\u307E\u3059\u3002",
                        en: "Practical workshops for M365, Google Workspace, SaaS, and AI products\u2014designed for non-engineers, not slide decks."
                    }
                }
            ]
        },
        faq: {
            heading: {
                ja: "\u3088\u304F\u3042\u308B\u3054\u8CEA\u554F",
                en: "FAQ"
            },
            items: [
                {
                    q: {
                        ja: "\u3069\u306E\u3088\u3046\u306A\u88FD\u54C1\u306E\u4ED5\u5165\u308C\u30FB\u63D0\u4F9B\u306B\u5BFE\u5FDC\u3057\u3066\u3044\u307E\u3059\u304B\uFF1F",
                        en: "What products can you procure?"
                    },
                    a: {
                        ja: "Microsoft 365\u3001Google Workspace\u3001\u5404\u7A2ESaaS\u3001AI\u88FD\u54C1\uFF08Copilot\u30FBGemini\u7B49\uFF09\u3001\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u88FD\u54C1\u3001\u30AF\u30E9\u30A6\u30C9\uFF08AWS/GCP/Azure\uFF09\u306E\u30E9\u30A4\u30BB\u30F3\u30B9\u30FB\u5229\u7528\u5951\u7D04\u306B\u5BFE\u5FDC\u3057\u3066\u3044\u307E\u3059\u3002PC\u30FBIT\u6A5F\u5668\u306F\u9806\u6B21\u5BFE\u5FDC\u4E88\u5B9A\u3067\u3059\u3002",
                        en: "Microsoft 365, Google Workspace, SaaS, AI products (Copilot, Gemini, etc.), security products, and cloud (AWS/GCP/Azure) licenses. PC and hardware supply coming soon."
                    }
                },
                {
                    q: {
                        ja: "PC\u30FBIT\u6A5F\u5668\u306E\u4ED5\u5165\u308C\u30FB\u8CA9\u58F2\u306F\u3044\u3064\u304B\u3089\u5BFE\u5FDC\u3057\u307E\u3059\u304B\uFF1F",
                        en: "When will PC and hardware supply be available?"
                    },
                    a: {
                        ja: "\u6CD5\u4EBA\u5411\u3051PC\u30FB\u5468\u8FBA\u6A5F\u5668\u306E\u4ED5\u5165\u308C\u30FB\u8CA9\u58F2\u3092\u9806\u6B21\u958B\u59CB\u4E88\u5B9A\u3067\u3059\u3002\u30AF\u30E9\u30A6\u30C9\u30FBSaaS\u74B0\u5883\u3068\u5408\u308F\u305B\u305F\u7AEF\u672B\u69CB\u6210\u306E\u3054\u76F8\u8AC7\u3082\u627F\u308A\u307E\u3059\u3002\u8A73\u7D30\u306F\u304A\u554F\u3044\u5408\u308F\u305B\u304F\u3060\u3055\u3044\u3002",
                        en: "Corporate PC and peripheral procurement and sales are launching soon. We can also advise on device configurations aligned with your cloud and SaaS stack\u2014contact us for details."
                    }
                },
                {
                    q: {
                        ja: "\u65E2\u5B58\u306EIT\u30D9\u30F3\u30C0\u30FC\u3068\u306E\u5354\u696D\u306F\u53EF\u80FD\u3067\u3059\u304B\uFF1F",
                        en: "Can you work with our existing vendors?"
                    },
                    a: {
                        ja: "\u53EF\u80FD\u3067\u3059\u3002\u304A\u5BA2\u69D8\u306E\u65E2\u5B58\u4F53\u5236\u3092\u5C0A\u91CD\u3057\u3064\u3064\u3001\u4E0D\u8DB3\u3059\u308B\u8A2D\u8A08\u30FB\u5B9F\u88C5\u9818\u57DF\u3092\u88DC\u5B8C\u3059\u308B\u5F62\u3067\u53C2\u753B\u3057\u307E\u3059\u3002",
                        en: "We complement your existing vendors\u2014filling design and build gaps without stepping on toes."
                    }
                },
                {
                    q: {
                        ja: "\u5C0E\u5165\u5F8C\u306E\u30B5\u30DD\u30FC\u30C8\u306F\u3042\u308A\u307E\u3059\u304B\uFF1F",
                        en: "Post-go-live support?"
                    },
                    a: {
                        ja: "\u904B\u7528\u4FDD\u5B88\u5951\u7D04\u3084\u30B9\u30DD\u30C3\u30C8\u652F\u63F4\u306B\u5BFE\u5FDC\u3002\u5185\u88FD\u5316\u3092\u76EE\u6307\u3059\u5834\u5408\u306F\u3001\u6BB5\u968E\u7684\u306A\u30CA\u30EC\u30C3\u30B8\u79FB\u8EE2\u30D7\u30E9\u30F3\u3082\u63D0\u6848\u3057\u307E\u3059\u3002",
                        en: "Managed support or spot help\u2014and phased knowledge transfer when you want to in-house it."
                    }
                },
                {
                    q: {
                        ja: "\u30E9\u30A4\u30BB\u30F3\u30B9\u9078\u5B9A\u3082\u652F\u63F4\u3057\u3066\u3082\u3089\u3048\u307E\u3059\u304B\uFF1F",
                        en: "Can you help with license selection?"
                    },
                    a: {
                        ja: "\u306F\u3044\u3002\u5229\u7528\u90E8\u9580\u3068\u6A5F\u80FD\u8981\u4EF6\u304B\u3089\u6700\u9069\u306A\u30D7\u30E9\u30F3\u3092\u6574\u7406\u3057\u3001\u904E\u5270\u30E9\u30A4\u30BB\u30F3\u30B9\u3092\u6291\u3048\u305F\u69CB\u6210\u3092\u63D0\u6848\u3057\u307E\u3059\u3002",
                        en: "Yes\u2014we map departments and features to right-sized plans and avoid over-licensing."
                    }
                },
                {
                    q: {
                        ja: "\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u8981\u4EF6\u304C\u53B3\u3057\u3044\u696D\u754C\u3067\u3082\u5BFE\u5FDC\u3067\u304D\u307E\u3059\u304B\uFF1F",
                        en: "Can you meet strict security requirements?"
                    },
                    a: {
                        ja: "\u91D1\u878D\u30FB\u516C\u5171\u30FB\u88FD\u9020\u306A\u3069\u3001\u30ED\u30B0\u4FDD\u7BA1\u30FB\u30A2\u30AF\u30BB\u30B9\u5236\u5FA1\u30FB\u30C7\u30FC\u30BF\u6240\u5728\u5730\u306E\u8981\u4EF6\u306B\u6CBF\u3063\u305F\u8A2D\u8A08\u306B\u5BFE\u5FDC\u3057\u307E\u3059\u3002",
                        en: "We design for finance, public sector, and manufacturing\u2014logging, access, and data residency included."
                    }
                },
                {
                    q: {
                        ja: "\u79FB\u884C\u4E2D\u306E\u30C0\u30A6\u30F3\u30BF\u30A4\u30E0\u306F\u3069\u306E\u7A0B\u5EA6\u60F3\u5B9A\u3057\u307E\u3059\u304B\uFF1F",
                        en: "How much downtime should we expect?"
                    },
                    a: {
                        ja: "\u30EF\u30FC\u30AF\u30ED\u30FC\u30C9\u3054\u3068\u306B\u5207\u308A\u66FF\u3048\u65B9\u5F0F\u3092\u8A2D\u8A08\u3057\u3001\u591C\u9593\u30FB\u4F11\u65E5\u306E\u77ED\u6642\u9593\u5207\u66FF\u3084\u4E26\u884C\u7A3C\u50CD\u3067\u5F71\u97FF\u3092\u6700\u5C0F\u5316\u3057\u307E\u3059\u3002",
                        en: "We plan per-workload cutovers\u2014night/weekend windows and parallel runs to minimize impact."
                    }
                },
                {
                    q: {
                        ja: "\u7814\u4FEE\u306F\u30AA\u30F3\u30E9\u30A4\u30F3\u3067\u3082\u5B9F\u65BD\u3067\u304D\u307E\u3059\u304B\uFF1F",
                        en: "Can training be delivered online?"
                    },
                    a: {
                        ja: "\u53EF\u80FD\u3067\u3059\u3002\u30E9\u30A4\u30D6\u7814\u4FEE\u30FB\u9332\u753B\u30B3\u30F3\u30C6\u30F3\u30C4\u30FB\u7BA1\u7406\u8005\u5411\u3051\u30CF\u30F3\u30BA\u30AA\u30F3\u306E\u7D44\u307F\u5408\u308F\u305B\u3067\u5B9A\u7740\u3092\u652F\u63F4\u3057\u307E\u3059\u3002",
                        en: "Yes\u2014live sessions, recordings, and admin workshops combined for adoption."
                    }
                },
                {
                    q: {
                        ja: "AI\u9023\u643A\u3092\u898B\u636E\u3048\u305F\u30C7\u30FC\u30BF\u8A2D\u8A08\u3068\u306F\u4F55\u3067\u3059\u304B\uFF1F",
                        en: "What is AI-ready data design?"
                    },
                    a: {
                        ja: "\u5C06\u6765\u306ERAG\u30FB\u5206\u6790\u5229\u7528\u3092\u60F3\u5B9A\u3057\u3001\u30C7\u30FC\u30BF\u5206\u985E\u30FB\u6A29\u9650\u30FB\u30E1\u30BF\u30C7\u30FC\u30BF\u3092\u6700\u521D\u304B\u3089\u6574\u3048\u308B\u3053\u3068\u3067\u3059\u3002",
                        en: "Classifying data, permissions, and metadata up front for future RAG and analytics use."
                    }
                },
                {
                    q: {
                        ja: "\u898B\u7A4D\u3082\u308A\u306E\u9032\u3081\u65B9\u3092\u6559\u3048\u3066\u304F\u3060\u3055\u3044\u3002",
                        en: "How do estimates work?"
                    },
                    a: {
                        ja: "\u73FE\u72B6\u30D2\u30A2\u30EA\u30F3\u30B0\u5F8C\u3001\u30D5\u30A7\u30FC\u30BA\u3054\u3068\u306E\u5DE5\u6570\u3068\u30AA\u30D7\u30B7\u30E7\u30F3\u3092\u63D0\u793A\u3057\u307E\u3059\u3002\u521D\u56DE\u76F8\u8AC7\u306F\u7121\u6599\u3067\u3059\u3002",
                        en: "After discovery we share phased effort and options\u2014the first consult is free."
                    }
                },
                {
                    q: {
                        ja: "\u8907\u6570\u62E0\u70B9\u30FB\u6D77\u5916\u62E0\u70B9\u304C\u3042\u308B\u5834\u5408\u3082\u5BFE\u5FDC\u3067\u304D\u307E\u3059\u304B\uFF1F",
                        en: "Multi-site and global rollouts?"
                    },
                    a: {
                        ja: "\u30C6\u30CA\u30F3\u30C8\u8A2D\u8A08\u30FB\u30CD\u30C3\u30C8\u30EF\u30FC\u30AF\u30FB\u30BF\u30A4\u30E0\u30BE\u30FC\u30F3\u3092\u8003\u616E\u3057\u305F\u6BB5\u968E\u5C55\u958B\u30D7\u30E9\u30F3\u3092\u7B56\u5B9A\u3057\u307E\u3059\u3002",
                        en: "We plan phased rollouts accounting for tenant design, networking, and time zones."
                    }
                }
            ]
        },
        cta: {
            heading: {
                ja: "\u88FD\u54C1\u9078\u5B9A\u30FB\u5C0E\u5165\u306E\u7B2C\u4E00\u6B69\u3092",
                en: "Take the first step"
            },
            body: {
                ja: "\u5FC5\u8981\u306A\u88FD\u54C1\u3084\u73FE\u72B6\u306E\u8AB2\u984C\u3092\u304A\u805E\u304B\u305B\u304F\u3060\u3055\u3044\u3002\u4ED5\u5165\u308C\u304B\u3089\u5C0E\u5165\u30FB\u5B9A\u7740\u307E\u3067\u3001\u6700\u9069\u306A\u30D7\u30E9\u30F3\u3092\u3054\u63D0\u6848\u3057\u307E\u3059\u3002",
                en: "Tell us what you need and what's blocking you\u2014we'll propose a plan from procurement through adoption."
            },
            button: {
                ja: "SaaS\u30FB\u30AF\u30E9\u30A6\u30C9\u5C0E\u5165\u306B\u3064\u3044\u3066\u76F8\u8AC7",
                en: "Discuss SaaS & cloud"
            }
        }
    },
    drone: {
        slug: "drone",
        canonical: "https://www.napire.co.jp/drone.html",
        pageTitle: {
            ja: "\u81EA\u793EAI\u30C9\u30ED\u30FC\u30F3 | \u682A\u5F0F\u4F1A\u793ENAPIRE",
            en: "In-house AI Drone | NAPIRE Inc."
        },
        metaDescription: {
            ja: "NAPIRE\u306E\u81EA\u793EAI\u30C9\u30ED\u30FC\u30F3\u3002\u767D\u7D19\u306E\u6A5F\u4F53\u304B\u3089\u8A2D\u8A08\u3057\u3001\u98DB\u884C\u5236\u5FA1\u304B\u3089\u8A8D\u8B58AI\u30FB\u5730\u4E0A\u7CFB\u307E\u3067\u4E00\u6C17\u901A\u8CAB\u3002\u8FB2\u696D\u30FB\u76E3\u8996\u30FB\u7269\u6D41\u306A\u3069\u73FE\u5834\u3067\u52D5\u304F\u81EA\u5F8B\u98DB\u884C\u30B7\u30B9\u30C6\u30E0\u3092\u958B\u767A\u3057\u307E\u3059\u3002",
            en: "NAPIRE's in-house AI drones\u2014airframe to flight control, perception, and ground ops. Autonomous systems built for agriculture, security, logistics, and more."
        },
        keywords: {
            ja: "AI\u30C9\u30ED\u30FC\u30F3,\u81EA\u793E\u958B\u767A,\u81EA\u5F8B\u98DB\u884C,Computer Vision,\u30A8\u30C3\u30B8\u63A8\u8AD6,\u7D44\u307F\u8FBC\u307F,NAPIRE",
            en: "AI drone,in-house,autonomous flight,computer vision,edge inference,NAPIRE"
        },
        hero: {
            eyebrow: {
                ja: "Product / AI Drone",
                en: "Product / AI Drone"
            },
            title: {
                ja: "\u30C9\u30ED\u30FC\u30F3\u306F\u3001\u767D\u7D19\u306E\u6A5F\u4F53\u304B\u3089\u3002",
                en: "Drones from a blank airframe."
            },
            lead: {
                ja: "\u30AD\u30C3\u30C8\u3092\u7D44\u3080\u306E\u3067\u306F\u306A\u304F\u3001\u7528\u9014\u304B\u3089\u6A5F\u4F53\u30FB\u63A8\u529B\u30FB\u30BB\u30F3\u30B5\u3092\u8A2D\u8A08\u3002AI\u30FBIT\u4F01\u696D\u3068\u3057\u3066\u57F9\u3063\u305F\u5B9F\u88C5\u529B\u3067\u3001\u98DB\u884C\u5236\u5FA1\u304B\u3089\u8A8D\u8B58AI\u30FB\u5730\u4E0A\u7CFB\u307E\u3067\u4E00\u6C17\u901A\u8CAB\u3067\u958B\u767A\u3057\u307E\u3059\u3002",
                en: "We don't assemble kits\u2014we design frames, thrust, and sensors for the mission. As an AI & IT builder, we ship flight control, perception, and ground ops end to end."
            },
            cta: {
                ja: "\u5C0E\u5165\u30FB\u5171\u540C\u958B\u767A\u3092\u76F8\u8AC7",
                en: "Discuss a build"
            }
        },
        questions: {
            heading: {
                ja: "\u3053\u3093\u306A\u9055\u548C\u611F\u3001\u3042\u308A\u307E\u305B\u3093\u304B\uFF1F",
                en: "Sound familiar?"
            },
            items: [
                {
                    q: {
                        ja: "\u65E2\u88FD\u54C1\u30C9\u30ED\u30FC\u30F3\u3067\u306F\u3001\u73FE\u5834\u306E\u8981\u4EF6\u3092\u6E80\u305F\u305B\u306A\u3044",
                        en: "Off-the-shelf drones miss our field requirements"
                    },
                    a: {
                        ja: "\u7528\u9014\u304B\u3089\u6A5F\u4F53\u30B5\u30A4\u30BA\u30FB\u63A8\u529B\u30FB\u30BB\u30F3\u30B5\u69CB\u6210\u3092\u9006\u7B97\u3057\u3001\u8A8D\u8B58\u7CBE\u5EA6\u3068\u822A\u7D9A\u30FB\u98A8\u8010\u6027\u307E\u3067\u542B\u3081\u3066\u4E00\u8CAB\u8A2D\u8A08\u3057\u307E\u3059\u3002",
                        en: "We size frames, thrust, and sensors from the mission\u2014accuracy, endurance, and wind tolerance designed together."
                    }
                },
                {
                    q: {
                        ja: "\u30C7\u30E2\u98DB\u884C\u306F\u6210\u529F\u3057\u305F\u304C\u3001\u672C\u756A\u904B\u7528\u3067\u7834\u7DBB\u3057\u305F",
                        en: "The demo flew\u2014production ops fell apart"
                    },
                    a: {
                        ja: "\u5730\u4E0A\u5C40\u3001\u30ED\u30B0\u3001OTA\u3001\u70B9\u691C\u30FB\u4EA4\u63DB\u3092\u6700\u521D\u304B\u3089\u7E54\u308A\u8FBC\u307F\u3002\u9577\u671F\u904B\u7528\u3092\u524D\u63D0\u3068\u3057\u305F\u30E2\u30B8\u30E5\u30FC\u30EB\u69CB\u6210\u3067\u5B9F\u88C5\u3057\u307E\u3059\u3002",
                        en: "Ground station, logging, OTA, and field maintenance woven in from day one\u2014not bolted on after the demo."
                    }
                },
                {
                    q: {
                        ja: "\u30CF\u30FC\u30C9\u3068\u30BD\u30D5\u30C8\u3092\u5225\u30D9\u30F3\u30C0\u30FC\u306B\u4EFB\u305B\u3001\u9023\u643A\u304C\u3046\u307E\u304F\u3044\u304B\u306A\u3044",
                        en: "Hardware and software vendors don't meet in the middle"
                    },
                    a: {
                        ja: "\u6A5F\u4F53\u30FB\u5236\u5FA1\u30FB\u8A8D\u8B58AI\u3092\u540C\u3058\u30C1\u30FC\u30E0\u304C\u62C5\u5F53\u3002\u63A8\u529B\u30E2\u30C7\u30EB\u3084IMU\u30CE\u30A4\u30BA\u3092\u8E0F\u307E\u3048\u305F\u63A8\u8AD6\u30D1\u30A4\u30D7\u30E9\u30A4\u30F3\u3092\u7121\u7406\u306A\u304F\u7D50\u7DDA\u3057\u307E\u3059\u3002",
                        en: "One team owns airframe, control, and perception\u2014wiring inference to real thrust and IMU behavior."
                    }
                }
            ]
        },
        services: {
            heading: {
                ja: "\u63D0\u4F9B\u9818\u57DF",
                en: "What we deliver"
            },
            items: [
                {
                    title: {
                        ja: "\u6A5F\u4F53\u30FB\u30CF\u30FC\u30C9\u30A6\u30A7\u30A2\u8A2D\u8A08",
                        en: "Airframe & hardware design"
                    },
                    desc: {
                        ja: "\u6A5F\u4F53\u9078\u5B9A\u301C\u30AB\u30B9\u30BF\u30E0\u30D5\u30EC\u30FC\u30E0\u3001\u30D7\u30ED\u30DA\u30E9\u3001ESC\u3001\u30D0\u30C3\u30C6\u30EA\u30FC\u3001\u5404\u7A2E\u30BB\u30F3\u30B5\u306E\u30DE\u30A6\u30F3\u30C8\u307E\u3067\u3092\u4E00\u3064\u306E\u8A2D\u8A08\u3068\u3057\u3066\u9032\u884C\u3002\u98A8\u30FB\u9AD8\u5EA6\u30FB\u822A\u7D9A\u3067\u9006\u7B97\u3057\u307E\u3059\u3002",
                        en: "Frame selection or custom builds, propulsion, power, and sensor mounts as one system\u2014traded against wind, altitude, and endurance."
                    }
                },
                {
                    title: {
                        ja: "\u98DB\u884C\u5236\u5FA1\u30FB\u30D5\u30A7\u30A4\u30EB\u30BB\u30FC\u30D5",
                        en: "Flight control & failsafes"
                    },
                    desc: {
                        ja: "\u5B89\u5B9A\u5316\u30FB\u9AD8\u5EA6\u4FDD\u6301\u30FB\u5E30\u9084\u30ED\u30B8\u30C3\u30AF\u3092\u5B9F\u6A5F\u306E\u6163\u6027\u30FB\u63A8\u529B\u30E2\u30C7\u30EB\u306B\u5408\u308F\u305B\u3066\u30C1\u30E5\u30FC\u30CB\u30F3\u30B0\u3002\u7269\u7406\u5236\u7D04\u306E\u4E2D\u3067\u52D5\u304F\u5236\u5FA1\u30EB\u30FC\u30D7\u3092\u5B9F\u88C5\u3057\u307E\u3059\u3002",
                        en: "Stabilization, altitude hold, and return-to-home tuned to real inertia and thrust\u2014not simulator defaults."
                    }
                },
                {
                    title: {
                        ja: "\u8A8D\u8B58AI\u30FB\u30A8\u30C3\u30B8\u63A8\u8AD6",
                        en: "Perception AI & edge inference"
                    },
                    desc: {
                        ja: "\u753B\u50CF\u691C\u77E5\u30FB\u8FFD\u5F93\u30FB\u30DE\u30C3\u30D4\u30F3\u30B0\u3092\u3001\u642D\u8F09\u30AB\u30E1\u30E9\u306E\u89E3\u50CF\u5EA6\u30FBFPS\u30FB\u9732\u51FA\u524D\u63D0\u3067\u8A2D\u8A08\u3002\u8FB2\u696D\u30FB\u76E3\u8996\u30FB\u70B9\u691C\u306A\u3069\u7528\u9014\u5225\u306E\u30E2\u30C7\u30EB\u3068\u5F8C\u51E6\u7406\u3092\u69CB\u7BC9\u3002",
                        en: "Detection, tracking, and mapping scoped to your payload\u2014mission-specific models for agriculture, security, and inspection."
                    }
                },
                {
                    title: {
                        ja: "\u5730\u4E0A\u5C40\u30FB\u904B\u7528\u57FA\u76E4",
                        en: "Ground station & ops platform"
                    },
                    desc: {
                        ja: "\u5730\u4E0A\u5C40UI\u3001\u30ED\u30B0\u30FB\u9065\u6E2C\u30B9\u30C8\u30EA\u30FC\u30DF\u30F3\u30B0\u3001OTA\u66F4\u65B0\u3001API\u9023\u643A\u307E\u3067\u542B\u3081\u305F\u904B\u7528\u57FA\u76E4\u3002\u73FE\u5834\u30AA\u30DA\u30EC\u30FC\u30BF\u30FC\u304C\u4F7F\u3044\u7D9A\u3051\u3089\u308C\u308B\u5F62\u306B\u4ED5\u4E0A\u3052\u307E\u3059\u3002",
                        en: "Ground UIs, telemetry, logging, OTA, and API integrations\u2014built for operators who run missions daily."
                    }
                }
            ]
        },
        process: {
            heading: {
                ja: "\u958B\u767A\u306E\u6D41\u308C",
                en: "How we work"
            },
            steps: [
                {
                    title: {
                        ja: "01 \u30DF\u30C3\u30B7\u30E7\u30F3\u5B9A\u7FA9",
                        en: "01 Define the mission"
                    },
                    desc: {
                        ja: "\u98DB\u884C\u7A7A\u57DF\u30FB\u822A\u7D9A\u30FB\u30DA\u30A4\u30ED\u30FC\u30C9\u30FB\u8A55\u4FA1\u6307\u6A19\u3092\u6574\u7406\u3002PoC\u3068\u672C\u756A\u904B\u7528\u306E\u5883\u754C\u3092\u660E\u78BA\u306B\u3057\u3001ROI\u304C\u898B\u3048\u308B\u30B9\u30B3\u30FC\u30D7\u306B\u7D5E\u308A\u8FBC\u307F\u307E\u3059\u3002",
                        en: "Align on airspace, endurance, payloads, and success metrics\u2014scoped PoCs with a clear path to production."
                    }
                },
                {
                    title: {
                        ja: "02 \u6A5F\u4F53\u30FB\u30BB\u30F3\u30B5\u8A2D\u8A08",
                        en: "02 Airframe & sensors"
                    },
                    desc: {
                        ja: "\u6A5F\u4F53\u30B5\u30A4\u30BA\u30FB\u63A8\u529B\u30FB\u30BB\u30F3\u30B5\u69CB\u6210\u3092\u7528\u9014\u304B\u3089\u8A2D\u8A08\u3002\u632F\u52D5\u30FB\u9732\u51FA\u30FB\u914D\u7DDA\u307E\u3067\u542B\u3081\u305F\u5B9F\u6A5F\u5236\u7D04\u3092\u5148\u306B\u53D6\u308A\u8FBC\u307F\u307E\u3059\u3002",
                        en: "Size frames, thrust, and sensors for the mission\u2014vibration, exposure, and wiring locked early."
                    }
                },
                {
                    title: {
                        ja: "03 \u5236\u5FA1\u30FB\u8A8D\u8B58\u306E\u7D71\u5408\u5B9F\u88C5",
                        en: "03 Integrate control & perception"
                    },
                    desc: {
                        ja: "\u98DB\u884C\u5236\u5FA1\u30EB\u30FC\u30D7\u3068\u63A8\u8AD6\u30D1\u30A4\u30D7\u30E9\u30A4\u30F3\u3092\u7D50\u7DDA\u3002\u30D9\u30F3\u30C1\u691C\u8A3C\u30FB\u5B9F\u6A5F\u30C1\u30E5\u30FC\u30CB\u30F3\u30B0\u3092\u7D4C\u3066\u3001\u73FE\u5834\u6761\u4EF6\u306B\u8010\u3048\u308B\u7D71\u5408\u30B7\u30B9\u30C6\u30E0\u3092\u69CB\u7BC9\u3057\u307E\u3059\u3002",
                        en: "Wire control loops and inference pipelines\u2014bench tests and field tuning until the stack survives real conditions."
                    }
                },
                {
                    title: {
                        ja: "04 \u5B9F\u8A3C\u98DB\u884C\u30FB\u904B\u7528\u79FB\u884C",
                        en: "04 Field validation & handoff"
                    },
                    desc: {
                        ja: "\u5B9F\u8A3C\u98DB\u884C\u3068\u8A55\u4FA1\u6307\u6A19\u306E\u691C\u8A3C\u3002\u904B\u7528\u624B\u9806\u30FB\u70B9\u691C\u30B5\u30A4\u30AF\u30EB\u30FB\u4FDD\u5B88\u4F53\u5236\u307E\u3067\u542B\u3081\u3066\u3001\u672C\u756A\u904B\u7528\u306B\u79FB\u884C\u3057\u307E\u3059\u3002",
                        en: "Validation flights against success criteria\u2014runbooks, inspection cycles, and maintenance for production ops."
                    }
                }
            ]
        },
        why: {
            heading: {
                ja: "NAPIRE\u304C\u9078\u3070\u308C\u308B\u7406\u7531",
                en: "Why NAPIRE"
            },
            items: [
                {
                    title: {
                        ja: "\u30CF\u30FC\u30C9\u5236\u7D04\u304CAI\u306E\u7CBE\u5EA6\u3092\u6C7A\u3081\u308B",
                        en: "Hardware sets AI accuracy"
                    },
                    body: {
                        ja: "\u30AB\u30E1\u30E9\u306E\u9732\u51FA\u30FB\u632F\u52D5\u30FBFPS\u2014\u2014\u6A5F\u4F53\u306B\u5408\u308F\u305B\u3066\u30E2\u30C7\u30EB\u3068\u5F8C\u51E6\u7406\u3092\u8A2D\u8A08\u3067\u304D\u308B\u304B\u3089\u3001\u73FE\u5834\u3067\u4F7F\u3048\u308B\u8A8D\u8B58\u304C\u51FA\u305B\u307E\u3059\u3002",
                        en: "Exposure, vibration, FPS\u2014models and post-processing scoped to the payload you actually carry."
                    }
                },
                {
                    title: {
                        ja: "\u5236\u5FA1\u3068\u8A8D\u8B58\u3092\u540C\u3058\u30C1\u30FC\u30E0\u3067",
                        en: "One team for control & perception"
                    },
                    body: {
                        ja: "\u63A8\u529B\u30E2\u30C7\u30EB\u30FBIMU\u30CE\u30A4\u30BA\u3092\u77E5\u3063\u3066\u3044\u308B\u304B\u3089\u3001\u5B89\u5B9A\u5316\u3068\u63A8\u8AD6\u30D1\u30A4\u30D7\u30E9\u30A4\u30F3\u3092\u7121\u7406\u306A\u304F\u7D50\u7DDA\u3067\u304D\u307E\u3059\u3002",
                        en: "Knowing thrust and IMU noise, we wire stabilization and inference without heroic hacks."
                    }
                },
                {
                    title: {
                        ja: "\u904B\u7528\u3067\u6B7B\u306A\u306A\u3044\u8A2D\u8A08",
                        en: "Built for long-running ops"
                    },
                    body: {
                        ja: "\u5730\u4E0A\u5C40\u3001\u30ED\u30B0\u3001OTA\u3001\u70B9\u691C\u30FB\u4EA4\u63DB\u3092\u898B\u636E\u3048\u305F\u30E2\u30B8\u30E5\u30FC\u30EB\u69CB\u6210\u3002\u30C7\u30E2\u3067\u7D42\u308F\u3089\u306A\u3044\u5F62\u306B\u3057\u307E\u3059\u3002",
                        en: "Ground station, logging, OTA, and field maintenance\u2014layouts meant to outlive the demo."
                    }
                }
            ]
        },
        faq: {
            heading: {
                ja: "\u3088\u304F\u3042\u308B\u3054\u8CEA\u554F",
                en: "FAQ"
            },
            items: [
                {
                    q: {
                        ja: "\u65E2\u88FD\u54C1\u30C9\u30ED\u30FC\u30F3\u3068\u306E\u9055\u3044\u306F\u4F55\u3067\u3059\u304B\uFF1F",
                        en: "How is this different from off-the-shelf drones?"
                    },
                    a: {
                        ja: "\u7528\u9014\u304B\u3089\u6A5F\u4F53\u30FB\u30BB\u30F3\u30B5\u30FB\u63A8\u8AD6\u30D1\u30A4\u30D7\u30E9\u30A4\u30F3\u3092\u4E00\u8CAB\u8A2D\u8A08\u3059\u308B\u305F\u3081\u3001\u6C4E\u7528\u6A5F\u3067\u306F\u96E3\u3057\u3044\u7CBE\u5EA6\u3068\u904B\u7528\u6027\u3092\u72D9\u3048\u307E\u3059\u3002",
                        en: "We co-design airframe, sensors, and inference for the mission\u2014accuracy and ops off-the-shelf kits can't match."
                    }
                },
                {
                    q: {
                        ja: "\u5171\u540C\u958B\u767A\u306F\u53EF\u80FD\u3067\u3059\u304B\uFF1F",
                        en: "Do you offer co-development?"
                    },
                    a: {
                        ja: "\u306F\u3044\u3002PoC\u304B\u3089\u91CF\u7523\u524D\u306E\u8A66\u4F5C\u307E\u3067\u3001\u304A\u5BA2\u69D8\u306E\u7528\u9014\u306B\u5408\u308F\u305B\u305F\u5171\u540C\u958B\u767A\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306B\u5BFE\u5FDC\u3057\u307E\u3059\u3002",
                        en: "Yes\u2014from PoC through pre-production prototypes tailored to your mission."
                    }
                },
                {
                    q: {
                        ja: "\u5BFE\u5FDC\u3057\u3066\u3044\u308B\u98DB\u884C\u898F\u5236\u30FB\u8A8D\u8A3C\u306B\u3064\u3044\u3066\u6559\u3048\u3066\u304F\u3060\u3055\u3044\u3002",
                        en: "What about regulations and certification?"
                    },
                    a: {
                        ja: "\u7528\u9014\u30FB\u98DB\u884C\u7A7A\u57DF\u306B\u5FDC\u3058\u305F\u7533\u8ACB\u8981\u4EF6\u3092\u6574\u7406\u3057\u3001\u5FC5\u8981\u306A\u8A66\u9A13\u30FB\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u6574\u5099\u3092\u652F\u63F4\u3057\u307E\u3059\u3002",
                        en: "We map airspace and mission rules and support required testing and documentation."
                    }
                },
                {
                    q: {
                        ja: "\u8FB2\u696D\u4EE5\u5916\u306E\u7523\u696D\u3067\u3082\u5229\u7528\u3067\u304D\u307E\u3059\u304B\uFF1F",
                        en: "Beyond agriculture?"
                    },
                    a: {
                        ja: "\u76E3\u8996\u3001\u30A4\u30F3\u30D5\u30E9\u70B9\u691C\u3001\u7269\u6D41\u3001\u707D\u5BB3\u5BFE\u5FDC\u306A\u3069\u3001\u30BB\u30F3\u30B5\u3068\u98DB\u884C\u30ED\u30B8\u30C3\u30AF\u3092\u5DEE\u3057\u66FF\u3048\u3066\u5BFE\u5FDC\u3057\u307E\u3059\u3002",
                        en: "Security, infrastructure inspection, logistics, disaster response\u2014swap sensors and flight logic per mission."
                    }
                },
                {
                    q: {
                        ja: "AI\u30E2\u30C7\u30EB\u306F\u30AF\u30E9\u30A6\u30C9\u63A8\u8AD6\u3067\u3059\u304B\uFF1F\u6A5F\u4E0A\u63A8\u8AD6\u3067\u3059\u304B\uFF1F",
                        en: "Cloud or onboard inference?"
                    },
                    a: {
                        ja: "\u30EC\u30A4\u30C6\u30F3\u30B7\u30FB\u901A\u4FE1\u30FB\u96FB\u529B\u306E\u5236\u7D04\u304B\u3089\u6700\u9069\u306A\u30CF\u30A4\u30D6\u30EA\u30C3\u30C9\u69CB\u6210\u3092\u63D0\u6848\u3057\u307E\u3059\u3002\u591A\u304F\u306E\u73FE\u5834\u5224\u65AD\u306F\u30A8\u30C3\u30B8\u3067\u51E6\u7406\u3057\u307E\u3059\u3002",
                        en: "We propose hybrid stacks\u2014most field decisions run at the edge given latency, bandwidth, and power limits."
                    }
                },
                {
                    q: {
                        ja: "\u958B\u767A\u671F\u9593\u3068\u8CBB\u7528\u306E\u76EE\u5B89\u306F\uFF1F",
                        en: "Typical timeline and cost?"
                    },
                    a: {
                        ja: "PoC\u306F2\u301C4\u30F6\u6708\u3001\u672C\u756A\u5411\u3051\u8A66\u4F5C\u306F\u8981\u4EF6\u306B\u3088\u308A\u7570\u306A\u308A\u307E\u3059\u3002\u521D\u56DE\u76F8\u8AC7\u3067\u30B9\u30B3\u30FC\u30D7\u3068\u6982\u7B97\u3092\u304A\u4F1D\u3048\u3057\u307E\u3059\u3002",
                        en: "PoCs often run 2\u20134 months; production prototypes vary\u2014we scope and estimate in the first consult."
                    }
                },
                {
                    q: {
                        ja: "\u65E2\u5B58\u306E\u5730\u4E0A\u30B7\u30B9\u30C6\u30E0\u3068\u9023\u643A\u3067\u304D\u307E\u3059\u304B\uFF1F",
                        en: "Integration with existing ground systems?"
                    },
                    a: {
                        ja: "API\u30FBMQTT\u30FB\u65E2\u5B58\u30C0\u30C3\u30B7\u30E5\u30DC\u30FC\u30C9\u3068\u306E\u9023\u643A\u3092\u8A2D\u8A08\u3002\u904B\u7528\u30C1\u30FC\u30E0\u304C\u4F7F\u3044\u7D9A\u3051\u3089\u308C\u308B\u5730\u4E0A\u5C40UI\u3082\u958B\u767A\u3057\u307E\u3059\u3002",
                        en: "We wire APIs, MQTT, and dashboards\u2014and build ground UIs operators will actually use."
                    }
                },
                {
                    q: {
                        ja: "\u4FDD\u5B88\u30FB\u70B9\u691C\u30FB\u90E8\u54C1\u4EA4\u63DB\u306F\u3069\u3046\u306A\u308A\u307E\u3059\u304B\uFF1F",
                        en: "Maintenance and parts?"
                    },
                    a: {
                        ja: "\u30E2\u30B8\u30E5\u30FC\u30EB\u4EA4\u63DB\u30FBOTA\u66F4\u65B0\u30FB\u70B9\u691C\u624B\u9806\u3092\u6700\u521D\u304B\u3089\u8A2D\u8A08\u3002\u9577\u671F\u904B\u7528\u3092\u524D\u63D0\u3068\u3057\u305F\u69CB\u6210\u306B\u3057\u307E\u3059\u3002",
                        en: "Modular swaps, OTA, and inspection runbooks\u2014built for long-running operations."
                    }
                },
                {
                    q: {
                        ja: "\u30C7\u30FC\u30BF\u306E\u53D6\u308A\u6271\u3044\u3068\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u306F\uFF1F",
                        en: "Data handling and security?"
                    },
                    a: {
                        ja: "\u6620\u50CF\u30FB\u30ED\u30B0\u306E\u4FDD\u5B58\u5834\u6240\u3001\u6697\u53F7\u5316\u3001\u30A2\u30AF\u30BB\u30B9\u6A29\u9650\u3092\u7528\u9014\u306B\u5408\u308F\u305B\u3066\u8A2D\u8A08\u3002\u9589\u57DF\u30CD\u30C3\u30C8\u30EF\u30FC\u30AF\u306B\u3082\u5BFE\u5FDC\u3057\u307E\u3059\u3002",
                        en: "We design storage, encryption, and access per mission\u2014including closed networks."
                    }
                },
                {
                    q: {
                        ja: "\u30C7\u30E2\u98DB\u884C\u3084\u6280\u8853\u691C\u8A3C\u306F\u4F9D\u983C\u3067\u304D\u307E\u3059\u304B\uFF1F",
                        en: "Can we request a demo flight or technical validation?"
                    },
                    a: {
                        ja: "\u53EF\u80FD\u3067\u3059\u3002\u76EE\u7684\u3068\u8A55\u4FA1\u6307\u6A19\u3092\u6574\u7406\u3057\u305F\u4E0A\u3067\u3001\u9650\u5B9A\u30B9\u30B3\u30FC\u30D7\u306E\u5B9F\u8A3C\u98DB\u884C\u30FB\u30D9\u30F3\u30C1\u691C\u8A3C\u3092\u63D0\u6848\u3057\u307E\u3059\u3002",
                        en: "Yes\u2014scoped demo flights and bench tests with clear success criteria."
                    }
                }
            ]
        },
        cta: {
            heading: {
                ja: "\u5171\u540C\u958B\u767A\u30FB\u5C0E\u5165\u306E\u3054\u76F8\u8AC7",
                en: "Co-development & rollout"
            },
            body: {
                ja: "PoC\u304B\u3089\u672C\u756A\u904B\u7528\u307E\u3067\u3002\u6A5F\u4F53\u8981\u4EF6\u304B\u3089\u304A\u805E\u304B\u305B\u304F\u3060\u3055\u3044\u3002",
                en: "From PoC to ops\u2014tell us your mission profile."
            },
            button: {
                ja: "\u30C9\u30ED\u30FC\u30F3\u306B\u3064\u3044\u3066\u76F8\u8AC7",
                en: "Talk drones"
            }
        }
    },
    shared: {
        nav: {
            home: {
                ja: "\u30DB\u30FC\u30E0",
                en: "Home"
            },
            aiDx: {
                ja: "AI\u30FBDX\u5C0E\u5165\u652F\u63F4",
                en: "AI & DX"
            },
            saasCloud: {
                ja: "SaaS\u30FB\u30AF\u30E9\u30A6\u30C9",
                en: "SaaS & Cloud"
            },
            contact: {
                ja: "\u304A\u554F\u3044\u5408\u308F\u305B",
                en: "Contact"
            }
        },
        breadcrumb: {
            home: {
                ja: "\u30DB\u30FC\u30E0",
                en: "Home"
            }
        },
        backHome: {
            ja: "\u30C8\u30C3\u30D7\u3078\u623B\u308B",
            en: "Back to home"
        }
    }
};

//# sourceMappingURL=corporate-site.f446feb2.js.map
